import { useEffect, useRef } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '@elva/platform';
import { ElvaPageLoader } from '@elva/ui';
import { readOAuthCallbackParams } from '../api/emailOauth';

/** Legacy callback route — redirect URI is `/settings/general-info`; keep for old links. */
export function SettingsEmailOauthCallbackPage() {
  const navigate = useNavigate();
  const authStatus = useAuthStore((s) => s.status);
  const startedRef = useRef(false);

  useEffect(() => {
    if (authStatus !== 'authenticated') return;
    if (startedRef.current) return;
    startedRef.current = true;

    const { code, state } = readOAuthCallbackParams();
    const query =
      code && state
        ? `?code=${encodeURIComponent(code)}&state=${encodeURIComponent(state)}`
        : '';

    navigate(`/settings/general${query}`, { replace: true });
  }, [authStatus, navigate]);

  return (
    <div className="flex min-h-[40vh] items-center justify-center">
      <ElvaPageLoader />
    </div>
  );
}

/**
 * `/settings/general-info` moved to `/settings/general` with the spec-15 settings
 * shell. Google's registered OAuth redirect URI still points at the old path, so
 * forward it with the query string intact — General info reads `code`/`state` from it.
 */
export function SettingsGeneralInfoLegacyRedirect() {
  const { search } = useLocation();
  return <Navigate to={{ pathname: '/settings/general', search }} replace />;
}
